import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../../index";
import { api } from "@/lib";
const name = "warehouseLocations";

if (Store.state[name]) {
  Store.unregisterModule(name);
}

@Module({ name: name, dynamic: true, store: Store, namespaced: true, stateFactory: true })
export default class WarehouseLocationsModule extends VuexModule {
  public loading: boolean = false;
  public error: boolean = false;
  public errorMessage: string = "";


  @Action
  async searchWarehouseLocationsTypeAhead(search) {
    let searchParams = "maxResults=200";
    if (search.typeAheadValue) {
      searchParams += `&typeAheadValue=${encodeURIComponent(search.typeAheadValue)}`;
    }
    if (search.facilityCode) {
      searchParams += `&facilityCode=${encodeURIComponent(search.facilityCode)}`;
    }
    if (search.excludeSystemLocations) {
      searchParams += "&excludeSystemLocations=true";
    }
    if (search.includeInActive) {
      searchParams += "&includeInActive=true";
    }

    return await api.getAsync(`/barcode/warehouselocations/typeAhead?${searchParams}`);
  }

  @Action
  async createWarehouseLocation(payload) {
    return await api.postAsync("/barcode/warehouselocations", payload);
  }  
  
  @Action
  async updateWarehouseLocation(payload) {
    return await api.putAsync(`/barcode/warehouselocations/${payload.id}`, payload);
  }

  
  @Action
  async forceUnlockWarehouseLocation(payload) {
    return await api.postAsync(`/barcode/warehouselocations/${payload.id}/unlock`, payload);
  }

  @Action
  async getWarehouseLocations(facilityCode, includeSystemLocations: boolean = true) {
    let filter = `includeSystemLocations=${includeSystemLocations ? "true" : "false"}`;
    if(facilityCode)  
      filter += `&facilityCodes=${facilityCode}`;
    return await api.getAsync(`/barcode/warehouselocations?${filter}`);
  }

  @Action
  async getWarehouseLocationInventoryItems(request) {
    return await api.getAsync(`/barcode/warehouselocations/${request.id}/inventoryItems?facilityCode=${request.facilityCode}`);
  }

  @Action
  async getWarehouseLocationPallets(request) {
    return await api.getAsync(`/barcode/warehouselocations/${request.id}/pallets?facilityCode=${request.facilityCode}`);
  }

  @Action
  async getWarehouseLocationBulkInventoryItems(request) {
    return await api.getAsync(`/barcode/warehouselocations/${request.id}/bulkInventoryItems?facilityCode=${request.facilityCode}`);
  }

  @Action
  async getWarehouseLocation(id: number) {
    return await api.getAsync(`/barcode/warehouselocations/${id}`);
  }
}
